import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getProfessional, getSpeciality, updateUserProfile, getCountry } from '../../lib/api';
import Dropdown from '../UI/Dropdown';
import Input from '../UI/Input';

const HCPProfessionalInfo = ({ userData, isEditProfessionalInfo, setUserData, setUnsavedChanges, setIsEditProfessionalInfo, setIsProfileUpdated, getUserProfileDetails, setIsLoading, handleEdit, handleCancel }) => {
    const { currentUser } = useSelector((state) => state.user);

    const [isInstitutionValid, setIsInstitutionIsValid] = useState(true)
    const [institutionError, setInstitutionError] = useState()
    const [isSpecialityValid, setSpecialityIsValid] = useState(false)
    const [isProfessionalValid, setProfessionalIsValid] = useState(true);
    const [specialityOptionsList, setSpecialityOptionsList] = useState([]);
    const [professionalOptionsList, setProfessionalOptionsList] = useState([]);
    const [professionId, setProfessionId] = useState()
    const [specialityMessage, setSpecialityMessage] = useState("");
    const [isCountryValid, setCountryIsValid] = useState(true)
    const [countryId, setCountryId] = useState()
    const [countryName, setCountryName] = useState()
    const [countryOptionsList, setCountryOptionsList] = useState([]);

    const { institution, selectedProfessionOption, selectedSpecialityOption, selectedSpecialityId, selectedProfessionId, selectedCountryName } = userData;

    const formValidation = (name, value) => {
        if (name === "institution") {
            if (!value) { setIsInstitutionIsValid(false); setInstitutionError("Please enter institution name") }
            else if (value[0] === ' ') { setIsInstitutionIsValid(false); setInstitutionError("Institution name cannot start with space") }
            else if (value.length > 100) { setIsInstitutionIsValid(false); setInstitutionError("Allowed max limit is 100 characters") }
            else if (value.match(/\d/)) { setIsInstitutionIsValid(false); setInstitutionError("Institution name cannot contain numeric values") }
            else if (value.match(/[\]\\!@=+~`_/[;'#$%^&*(),.?":{}|<>]/)) { setIsInstitutionIsValid(false); setInstitutionError("Institution name cannot contain special characters") }
            else { setInstitutionError(''); setIsInstitutionIsValid(true); }
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        let { name, value } = e.target;
        formValidation(name, value)
        // setUnsavedChanges(true)
        setUserData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleOnSelect = (dropdownNumber, option) => {
        // setUnsavedChanges(true)
        if (dropdownNumber === 1) {
            setUserData((prev) => ({
                ...prev,
                selectedProfessionId: option.id,
                selectedProfessionOption: option.value,
                selectedSpecialityOption: null
            }));
            setProfessionId(option.id)
            setProfessionalIsValid(true);
            setSpecialityIsValid(false);
            specialitysendRequest(option.id);
            // setSpecialityMessage("Please select your speciality.");
        } else if (dropdownNumber === 2) {
            setUserData((prev) => ({
                ...prev,
                selectedSpecialityId: option.id,
                selectedSpecialityOption: option.value
            }));
        }
    }

    const handleBlur = (dropdownNumber, isValid) => {
        if (dropdownNumber === 1) {
            setProfessionalIsValid(isValid);
        } else if (dropdownNumber === 2) {
            setSpecialityIsValid(isValid);
        }
    };

    const handleBlurCountry = (isValid) => {
        setCountryIsValid(isValid);
    };

    let formIsValid = false;
    if (
        isInstitutionValid
    ) {
        formIsValid = true
    }
    const handleProfileUpdate = (event) => {
        if (!formIsValid) {
            return;
        }
        setIsLoading(true)
        event.preventDefault();
        const updateData = {
            field_institution_name: { value: institution },
            field_profession: { value: professionId ? professionId : selectedProfessionId },
            field_specialty: { value: selectedSpecialityId },
            field_country: { value: countryName ?? selectedCountryName },
        }

        updateUserProfile(currentUser.access_token, currentUser.current_user.uid, updateData)
            .then(async (res) => {
                getUserProfileDetails();
                setProfessionId()
                setIsLoading(false)
                setUnsavedChanges(false)
                setIsEditProfessionalInfo(false)
                setIsProfileUpdated(true)
            })
    }

    const cancelChangesMade = () => {
        setSpecialityMessage("")
        setInstitutionError('')
        setSpecialityOptionsList([])
        setSpecialityIsValid(false)
        setIsInstitutionIsValid()
        setCountryName()
        setProfessionId()
        handleCancel()
    }

    const specialitysendRequest = (profession_id) => {
        getSpeciality(profession_id)
            .then((response) => {
                const options = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setSpecialityOptionsList(options);
                if (options.length === 0) {
                    setSpecialityMessage("No speciality found for selected profession!");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const professionalsendRequest = useCallback(() => {
        getProfessional()
            .then((response) => {
                const options = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setProfessionalOptionsList(options);
                specialitysendRequest(options[0].id);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])

    const handleOnSelectCountry = (option) => {
        //setUnsavedChanges(true)
        setCountryIsValid(true);
        setCountryId(option.id)
        setCountryName(option.value)
        setUserData((prev) => ({
            ...prev,
            selectedCountryName: option.value,
        }));
    }

    const countrysendRequest = useCallback(() => {
        getCountry()
            .then((response) => {
                const options = response?.data.map((details) => ({
                    id: details.id,
                    value: details.country_name,
                }));
                //  const selectedCountryOption = options.filter(option => option.value === selectedCountryName)
                setCountryName(selectedCountryName)
                setCountryOptionsList(options);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])

    useEffect(() => {
        professionalsendRequest()
        countrysendRequest();
    }, [])

    const institutionClasses = !isInstitutionValid
        ? "nameSection  flex flex-col gap-1 invalid"
        : "nameSection  flex flex-col gap-1 ";

    return (
        <div className="professions flex flex-col gap-5">
            <div className="flex justify-between gap-4 items-center pb-4 border-b border-b-[#ddd]">
                <h3 className="professionalSubTitle text-[#333] text-base sm:text-lg font-bold leading-normal">Professional Info</h3>
                <div className="editOption flex gap-[6px] items-center cursor-pointer">
                    {!isEditProfessionalInfo ? <div className="flex items-center gap-1" onClick={() => handleEdit(2)}><span className="editIcon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.698289">
                                <path fillRule="evenodd" clipRule="evenodd" d="M10.7736 1.62902C11.6123 0.790326 12.972 0.790326 13.8107 1.62902L14.3707 2.18902C15.2081 3.02827 15.2081 4.38689 14.3707 5.22614L5.85682 13.7404C5.79847 13.7988 5.72614 13.8409 5.64673 13.8629L1.60463 14.9827C1.43891 15.0286 1.26144 14.9818 1.1397 14.8602C1.01816 14.7385 0.971369 14.561 1.01741 14.3953L2.13704 10.3532C2.15904 10.2738 2.20117 10.2014 2.25952 10.1431L10.7736 1.62902ZM10.2675 3.485L3.29936 10.4533L5.54644 12.7006L12.5147 5.73227L10.2675 3.485ZM2.85046 11.3541L4.64585 13.1496L2.16239 13.8377L2.85046 11.3541ZM13.1898 5.05743L13.6959 4.55131C14.161 4.08508 14.161 3.33027 13.6959 2.86385L13.1357 2.30385C12.6698 1.838 11.9145 1.838 11.4486 2.30385L10.9423 2.80998L13.1898 5.05743Z" fill="#717375" />
                                <path d="M13.8107 1.62902L13.9875 1.45224V1.45224L13.8107 1.62902ZM10.7736 1.62902L10.5968 1.45224V1.45224L10.7736 1.62902ZM14.3707 2.18902L14.5477 2.01244L14.5475 2.01224L14.3707 2.18902ZM14.3707 5.22614L14.5475 5.40291L14.5477 5.40272L14.3707 5.22614ZM5.85682 13.7404L6.0336 13.9172L6.0336 13.9172L5.85682 13.7404ZM5.64673 13.8629L5.57999 13.622L5.57999 13.622L5.64673 13.8629ZM1.60463 14.9827L1.6713 15.2236L1.67138 15.2236L1.60463 14.9827ZM1.1397 14.8602L0.962793 15.0369L0.963063 15.0371L1.1397 14.8602ZM1.01741 14.3953L1.25829 14.4622L1.25834 14.462L1.01741 14.3953ZM2.13704 10.3532L1.89611 10.2865H1.89611L2.13704 10.3532ZM2.25952 10.1431L2.43629 10.3199H2.43629L2.25952 10.1431ZM3.29936 10.4533L3.12258 10.2765L2.94581 10.4533L3.12257 10.6301L3.29936 10.4533ZM10.2675 3.485L10.4442 3.30822L10.2675 3.13144L10.0907 3.30822L10.2675 3.485ZM5.54644 12.7006L5.36965 12.8773L5.54643 13.0541L5.72321 12.8773L5.54644 12.7006ZM12.5147 5.73227L12.6915 5.90904L12.8683 5.73227L12.6915 5.55549L12.5147 5.73227ZM4.64585 13.1496L4.7126 13.3906L5.12581 13.2761L4.82264 12.9729L4.64585 13.1496ZM2.85046 11.3541L3.02725 11.1773L2.72403 10.8741L2.60954 11.2873L2.85046 11.3541ZM2.16239 13.8377L1.92147 13.771L1.80357 14.1966L2.22914 14.0786L2.16239 13.8377ZM13.6959 4.55131L13.8727 4.72808L13.8729 4.72787L13.6959 4.55131ZM13.1898 5.05743L13.013 5.23421L13.1898 5.41099L13.3665 5.23421L13.1898 5.05743ZM13.6959 2.86385L13.8729 2.68732L13.8726 2.68705L13.6959 2.86385ZM13.1357 2.30385L12.9589 2.48063L12.9589 2.48066L13.1357 2.30385ZM11.4486 2.30385L11.6254 2.48066L11.6254 2.48063L11.4486 2.30385ZM10.9423 2.80998L10.7656 2.63317L10.5887 2.80995L10.7655 2.98675L10.9423 2.80998ZM13.9875 1.45224C13.0512 0.515919 11.5331 0.515919 10.5968 1.45224L10.9504 1.8058C11.6914 1.06473 12.8929 1.06473 13.6339 1.8058L13.9875 1.45224ZM14.5475 2.01224L13.9875 1.45224L13.6339 1.8058L14.1939 2.3658L14.5475 2.01224ZM14.5477 5.40272C15.4824 4.46588 15.4824 2.94928 14.5477 2.01244L14.1937 2.3656C14.9338 3.10727 14.9338 4.30789 14.1937 5.04956L14.5477 5.40272ZM6.0336 13.9172L14.5475 5.40291L14.1939 5.04937L5.68004 13.5636L6.0336 13.9172ZM5.71347 14.1038C5.83445 14.0703 5.9447 14.0061 6.0336 13.9172L5.68005 13.5636C5.65225 13.5914 5.61784 13.6115 5.57999 13.622L5.71347 14.1038ZM1.67138 15.2236L5.71348 14.1038L5.57999 13.622L1.53789 14.7418L1.67138 15.2236ZM0.963063 15.0371C1.14838 15.2222 1.41875 15.2935 1.6713 15.2236L1.53796 14.7417C1.45906 14.7636 1.37449 14.7414 1.31635 14.6833L0.963063 15.0371ZM0.776539 14.3284C0.706325 14.5811 0.777758 14.8515 0.962793 15.0369L1.31662 14.6836C1.25856 14.6254 1.23641 14.541 1.25829 14.4622L0.776539 14.3284ZM1.89611 10.2865L0.776486 14.3286L1.25834 14.462L2.37797 10.4199L1.89611 10.2865ZM2.08274 9.96632C1.99384 10.0552 1.92962 10.1655 1.89611 10.2865L2.37797 10.4199C2.38845 10.3821 2.4085 10.3477 2.43629 10.3199L2.08274 9.96632ZM10.5968 1.45224L2.08274 9.96632L2.43629 10.3199L10.9504 1.8058L10.5968 1.45224ZM3.47614 10.6301L10.4443 3.66177L10.0907 3.30822L3.12258 10.2765L3.47614 10.6301ZM5.72322 12.5238L3.47614 10.2765L3.12257 10.6301L5.36965 12.8773L5.72322 12.5238ZM12.338 5.55549L5.36966 12.5238L5.72321 12.8773L12.6915 5.90904L12.338 5.55549ZM10.0907 3.66177L12.338 5.90904L12.6915 5.55549L10.4442 3.30822L10.0907 3.66177ZM4.82264 12.9729L3.02725 11.1773L2.67368 11.5308L4.46907 13.3264L4.82264 12.9729ZM2.22914 14.0786L4.7126 13.3906L4.5791 12.9087L2.09564 13.5968L2.22914 14.0786ZM2.60954 11.2873L1.92147 13.771L2.40332 13.9045L3.09139 11.4208L2.60954 11.2873ZM13.5191 4.37453L13.013 4.88066L13.3665 5.23421L13.8727 4.72808L13.5191 4.37453ZM13.5189 3.04038C13.8867 3.40924 13.8866 4.00611 13.5189 4.37474L13.8729 4.72787C14.4354 4.16404 14.4353 3.2513 13.8729 2.68732L13.5189 3.04038ZM12.9589 2.48066L13.5191 3.04066L13.8726 2.68705L13.3124 2.12705L12.9589 2.48066ZM11.6254 2.48063C11.9936 2.1124 12.5907 2.1124 12.9589 2.48063L13.3125 2.12708C12.749 1.56359 11.8353 1.56359 11.2718 2.12708L11.6254 2.48063ZM11.119 2.98679L11.6254 2.48066L11.2719 2.12704L10.7656 2.63317L11.119 2.98679ZM13.3665 4.88066L11.1191 2.6332L10.7655 2.98675L13.013 5.23421L13.3665 4.88066Z" fill="#717375" />
                            </g>
                        </svg>
                    </span>
                        <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue">Edit</span></div> : <>
                        <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue" onClick={(e) => handleProfileUpdate(e)}>Save |</span>
                        <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue" onClick={cancelChangesMade}>Cancel</span></>}
                </div>
            </div>
            <div className="infoHolder pl-5">
                <div className="flex gap-6 sm:gap-6 responsiveGrid">
                    <div className="profession">
                        <div className={isEditProfessionalInfo ? "flex flex-col" : "flex flex-col gap-[6px]"}>
                            <label className="text-[#999] font-normal leading-normal sm:text-sm text-xs">Profession</label>
                            {!isEditProfessionalInfo ? <p className="text-[#373A3C] leading-normal font-medium text-sm sm:text-base">{selectedProfessionOption}</p> : <div className="professionSection gap-1 flex flex-col relative">
                                <Dropdown
                                    labelClass="professtionLabel text-[#333] text-sm font-normal leading-5"
                                    placeholder="Select a Profession"
                                    options={professionalOptionsList}
                                    onSelect={(option) => handleOnSelect(1, option)}
                                    selectedValue={{ id: selectedProfessionId, value: selectedProfessionOption }}
                                    onBlur={(isValid) => handleBlur(1, isValid)}
                                    isValid={isProfessionalValid}
                                />
                                {!isProfessionalValid && (
                                    <p className="error-text">
                                        Please select your profession.
                                    </p>
                                )}
                            </div>}
                        </div>
                    </div>
                    <div className="speciality">
                        <div className={isEditProfessionalInfo ? "flex flex-col" : "flex flex-col gap-[6px]"}>
                            <label className="text-[#999] font-normal leading-normal sm:text-sm text-xs">Speciality</label>
                            {!isEditProfessionalInfo ? <p className="text-[#373A3C] leading-normal font-medium text-sm sm:text-base">
                                {selectedSpecialityOption} </p> : <div className="professionSection gap-1 flex flex-col relative">
                                <Dropdown
                                    labelClass="professtionLabel text-[#333] text-sm font-normal leading-5"
                                    placeholder="Select a Speciality"
                                    options={specialityOptionsList}
                                    onSelect={(option) => handleOnSelect(2, option)}
                                    selectedValue={{ id: selectedSpecialityId, value: selectedSpecialityOption }}
                                    onBlur={(isValid) => handleBlur(2, isValid)}
                                    isValid={isSpecialityValid}
                                />
                                {!isSpecialityValid && (
                                    <p className="error-text">
                                        {specialityMessage}
                                    </p>
                                )}
                            </div>}
                        </div>
                    </div>
                    <div className="instituition">
                        <div className="flex flex-col gap-[6px]">
                            <label className="text-[#999] font-normal leading-normal sm:text-sm text-xs">Institution </label>
                            {!isEditProfessionalInfo ? <p className="text-[#373A3C] leading-normal font-medium text-sm sm:text-base">{institution}</p> : <div className={institutionClasses}>
                                <Input
                                    className="flex flex-col gap-0"
                                    labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                    input={{
                                        id: "institution",
                                        name: "institution",
                                        type: "text",
                                        value: institution,
                                        placeholder: "Enter institution name",
                                        onChange: handleChange,
                                        className:
                                            "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                    }}
                                />
                                {!isInstitutionValid && (
                                    <p className="error-text">
                                        {institutionError}
                                    </p>
                                )}
                            </div>}
                        </div>
                    </div>
                    <div className="speciality">
                        <div className={isEditProfessionalInfo ? "flex flex-col" : "flex flex-col gap-[6px]"}>
                            <label className="text-[#999] font-normal leading-normal sm:text-sm text-xs">Country</label>
                            {!isEditProfessionalInfo ? <p className="text-[#373A3C] leading-normal font-medium text-sm sm:text-base">
                                {countryName ?? selectedCountryName} </p> : <div className="professionSection gap-1 flex flex-col relative">
                                <Dropdown
                                    labelClass="professtionLabel text-[#333] text-sm font-normal leading-5"
                                    placeholder="Select a Country"
                                    options={countryOptionsList}
                                    onSelect={(option) => handleOnSelectCountry(option)}
                                    selectedValue={{ id: countryId, value: selectedCountryName }}
                                    onBlur={(isValid) => handleBlurCountry(isValid)}
                                    isValid={isCountryValid}
                                    type={'country'}
                                />
                                {!isCountryValid && (
                                    <p className="error-text">
                                        Please select your country
                                    </p>
                                )}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HCPProfessionalInfo;